import { get, post, getCsrfHeaders } from "./api_helper"
import { ADMIN_MUST_READ, ME_MUST_READ, ADMIN_DOCUMENTS } from "./url_helper"

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://clientportal.coldblock.ca/api"
const unwrap = (res) => res?.data

export const getMyMustRead = () => get(ME_MUST_READ).then(unwrap)
export const getMyMustReadContent = (itemId) => get(`${ME_MUST_READ}/${itemId}/content`).then(unwrap)
export const saveMustReadProgress = (itemId, body) => post(`${ME_MUST_READ}/${itemId}/progress`, body).then(unwrap)
export const completeMustRead = (itemId, versionId) =>
  post(`${ME_MUST_READ}/${itemId}/complete`, { versionId }).then(unwrap)
export const dismissMustReadBanner = () => post(`${ME_MUST_READ}/banner/dismiss`, {}).then(unwrap)

export const getAdminMustRead = () => get(ADMIN_MUST_READ).then(unwrap)
export const getMustReadVersions = (itemId) => get(`${ADMIN_MUST_READ}/${itemId}/versions`).then(unwrap)
export const publishMustRead = (body) => post(`${ADMIN_MUST_READ}/publish`, body).then(unwrap)
export const previewMustReadRecipients = (audiences) =>
  post(`${ADMIN_MUST_READ}/recipients-preview`, { audiences }).then(unwrap)
export const getMustReadStatus = (params) => get(`${ADMIN_MUST_READ}/status`, { params }).then(unwrap)

export const listResourceDocuments = () =>
  get(ADMIN_DOCUMENTS, { params: { all: true } }).then((res) => res?.data?.items || [])

export async function uploadMustReadFile(file) {
  const fd = new FormData()
  fd.append("file", file)
  fd.append("access", "private")
  const resp = await fetch(`${API_BASE}/uploads/direct`, {
    method: "POST",
    credentials: "include",
    headers: getCsrfHeaders(),
    body: fd,
  })
  const out = await resp.json().catch(() => ({}))
  if (!resp.ok || !out?.key) throw new Error(out?.message || "Upload failed")

  const created = await post(ADMIN_DOCUMENTS, {
    name: file.name.replace(/\.[^.]+$/, ""),
    fileName: file.name,
    mimeType: file.type || "application/octet-stream",
    size: file.size,
    companyIds: [],
    fileUrl: out.publicUrl,
    fileKey: out.key,
  })
  const doc = created?.data?.document
  return { documentId: doc.id, name: doc.name, mimeType: doc.mimeType }
}
